<template>
  <div class="session-chat-page">
    <div class="chat-toolbar">
      <ButtonVue icon="pi pi-arrow-left" label="Назад к сессиям" severity="secondary" text @click="goBack" />
    </div>
    <div v-if="loading" class="loading-wrap">
      <ProgressSpinner />
    </div>
    <p v-else-if="error" class="error-text">{{ error }}</p>
    <ChatThread
      v-else-if="session"
      :messages="session.messages"
      :user-id="session.user_id"
      :session-id="session.id"
      :updated-at="session.updated_at"
      class="chat-main"
    />
  </div>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import ProgressSpinner from 'primevue/progressspinner';
import { useToast } from 'primevue/usetoast';
import ChatThread from '@/components/rag-monitor/ChatThread.vue';
import { getSessionById } from '@/services/ragMonitorApi';

const route = useRoute();
const router = useRouter();
const toast = useToast();

const loading = ref(false);
const error = ref('');
const session = ref(null);

async function loadSession() {
  const id = route.params.id;
  if (!id) return;
  loading.value = true;
  error.value = '';
  session.value = null;
  try {
    session.value = await getSessionById(id);
  } catch (e) {
    error.value = e.message || 'Сессия не найдена';
    toast.add({ severity: 'error', summary: 'Ошибка', detail: error.value, life: 5000 });
  } finally {
    loading.value = false;
  }
}

function goBack() {
  router.push('/rag-monitor/sessions');
}

watch(() => route.params.id, loadSession);
onMounted(loadSession);
</script>

<style scoped>
.session-chat-page {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 180px);
  min-height: 400px;
}

.chat-toolbar {
  margin-bottom: 0.75rem;
}

.chat-main {
  flex: 1;
  min-height: 0;
}

.loading-wrap {
  display: flex;
  justify-content: center;
  padding: 3rem;
}

.error-text {
  color: var(--p-red-500, #dc3545);
  padding: 1rem;
}
</style>
